/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';

import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled';
import { getStatusCode } from '@confluence/error-boundary/entry-points/isStatusCodeError';

import type { useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery as useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$data } from './__types__/useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery';

type UseOrgDefaultClassificationLevelIdProps = {
	skip?: boolean;
};

type UseOrgDefaultClassificationLevelIdType = {
	orgDefaultClassificationLevelId: string | null;
	orgDefaultClasificationLoading: boolean;
	orgDefaultClassificationError?: ApolloErrorInterop;
};

const shouldMarkErrorAsHandled = (error?: ApolloErrorInterop) => {
	if (!error) return true;
	const statusCode = getStatusCode(error?.graphQLErrors?.[0]);
	if (!statusCode) return true;
	return !!(parseInt(statusCode) >= 400 && parseInt(statusCode) < 500);
};

export const useOrgDefaultClassificationLevelId = ({
	skip,
}: UseOrgDefaultClassificationLevelIdProps): UseOrgDefaultClassificationLevelIdType => {
	const { data, loading, error } =
		useQuery<useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$data>(
			gql`
				query useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery {
					orgDefaultClassificationLevelId
				}
			`,
			{ skip },
		);

	if (shouldMarkErrorAsHandled(error)) {
		markErrorAsHandled(error);
	}

	const orgDefaultClassificationLevelId = data?.orgDefaultClassificationLevelId ?? null;

	return {
		orgDefaultClassificationLevelId,
		orgDefaultClasificationLoading: loading,
		orgDefaultClassificationError: !shouldMarkErrorAsHandled(error) ? error : undefined,
	};
};
